<template>
  <b-card no-body class="border-0 shadow p-2 mb-4">
    <b-card-header header-tag="header" class="p-0 border-0" role="tab">
      <h5 class="p-2">
        <i class="fa fa-clock-o" />
        UBICACIONES TEMPORALES
      </h5>
    </b-card-header>
    <b-card-body class="py-3 px-0">
      <b-row>
        <b-col sm="12">
          <b-table
            responsive
            striped
            hover
            small
            :items="temporaryLocations"
            :fields="columns"
            thead-tr-class="table-active"
            class="mb-0"
            empty-text="No hay ubicaciones temporales para mostrar"
            show-empty
          >
            <template v-slot:cell(moduleCreated)="data">
              <b-badge
                v-if="data.item.checklist.length"
                variant="primary"
                v-text="'Inspecciones'"
              />
              <b-badge v-else variant="success" v-text="'Tickets'" />
            </template>

            <template v-if="validarPermisoComponente('empresa-editar-ubicaciones')" v-slot:cell(actions)="data">
              <el-tooltip content="Aprobar" placement="bottom" effect="light">
                <a class="botonProduct" @click="setModalLocal(data.item)">
                  <i class="fa fa-check text-success" />
                </a>
              </el-tooltip>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-card-body>
    <createLocationModal />
  </b-card>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import createLocationModal from "./modal";
import { validarPermisoComponente } from "@/plugins/acl";

export default {
  components: {
    createLocationModal,
  },
  name: "temporaryLocations",
  data() {
    return {
      temporaryLocation: null,
      validarPermisoComponente: validarPermisoComponente,
    };
  },
  watch: {
    newLocation: {
      handler: async function (val) {
        if (val) {
          await this.confirmTemporaryLocationLocal();
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapState("location", ["temporaryLocations", "selectedUbicacion", "newLocation"]),
    columns() {
      const columnsBase = [
        {
          key: "name",
          label: "Nombre",
          sortable: true,
          thStyle: "width: 200px; max-width:200px",
        },

        {
          key: "created_at",
          label: "Fecha_de_creación",
          tdClass: "text-uppercase",
          sortable: true,
        },
        {
          key: "moduleCreated",
          label: "Módulo_de_creación",
          tdClass: "text-uppercase",
          sortable: true,
        },
      ];

      if(this.validarPermisoComponente('empresa-editar-ubicaciones')){
        columnsBase.push({
          key: "actions",
          label: "Opciones",
          tdClass: "text-center",
          thClass: "text-center",
          thStyle: "width: 120px; max-width:120px",
        });
      }

      return columnsBase;
    },
  },
  methods: {
    ...mapActions("location", [
      "listarNivelActivos",
      "listLocationsActive",
      "confirmTemporaryLocation",
      "listLevels",
      "listarUbicaciones",
      "arbolUbicacionesEmpresa",
      "getTemporaryLocations",
    ]),
    ...mapMutations("location", ["setModal", "setSelectedUbicacion", "setModuleCreated"]),
    async setModalLocal(location) {
      this.temporaryLocation = location;
      this.setModuleCreated("temporaryLocations");
      await this.listarNivelActivos();
      await this.listLocationsActive();
      let data = {
        description: location.name,
        active: 1,
        parent: false,
        slq_location_id: null,
        slq_company_id: location.company_id,
        slq_locations_level_id: null,
      };
      this.setSelectedUbicacion(data);
      this.setModal(true);
    },
    async confirmTemporaryLocationLocal() {
      await this.confirmTemporaryLocation({
        slq_location_id: this.newLocation.data.id,
        company_id: this.temporaryLocation.company_id,
        temporary_location_id: this.temporaryLocation.id,
      });
      await this.listLevels();
      await this.listarUbicaciones();
      await this.arbolUbicacionesEmpresa();
      await this.getTemporaryLocations();
    },
  },
};
</script>

<style scoped></style>
